// Phase 6 — Track D T-D1. useDashboard hook.
//
// Wraps GET /api/dashboard via react-query. The singleton apiClient lives at
// `web/src/app/apiClient.ts`; the global queryClient (Dispatch 3) auto-signs
// out + redirects on AuthRequiredError, so the hook does not need to handle
// 401s explicitly.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { DashboardResponse } from '@dailydeck/shared/types';
import { apiClient } from '../app/apiClient.js';

export const DASHBOARD_QUERY_KEY = ['dashboard'] as const;

export function useDashboard(): UseQueryResult<DashboardResponse, Error> {
  return useQuery<DashboardResponse, Error>({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: () => apiClient.dashboard.list(),
  });
}
